// extracted by mini-css-extract-plugin
export default {"aglmd-icon":"uCYI2UbBfRgY4E7e6Yg8","aglmd-icon--fw":"PIwI0uvxoTER4CpjYbUt"};